var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["product-review-recommended-icon.j2"] = require( "product-review-recommended-icon.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-reviews-summary-recommendation.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "recommendedPercentage") && runtime.contextOrFrameLookup(context, frame, "recommendedPercentage") > 0) {
output += "\n\n    <div class=\"c-product-reviews-summary__section\">\n\n        <div class=\"c-product-reviews-summary__heading\">\n\n            ";
output += runtime.suppressValue((lineno = 6, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-recommended-percentage",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "recommendedPercentage")]})])), env.opts.autoescape);
output += "\n\n        </div>\n\n        <div class=\"c-product-reviews-summary__icon\">\n\n            <div class=\"c-product-reviews-summary__icon--recommended\">\n\n                ";
env.getTemplate("product-review-recommended-icon.j2", false, "product/templates/product-reviews-summary-recommendation.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n                \n            </div>\n\n        </div>\n\n    </div>\n\n";
})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-reviews-summary-recommendation.j2"] , dependencies)